import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { Space, TablePaginationConfig } from 'antd';
import { FilterValue, SorterResult } from 'antd/es/table/interface';
import { Column, RecordCountBadge, Table } from 'components';
import {
  StyledTableHeader,
  StyledTableWrapper,
} from 'components/table/table.styled';
import { PackageFilterFormPaginated } from 'features/package/components/package-filter-form/type';
import { usePermissions } from 'features/users';
import { Dispatch, SetStateAction } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from 'routes/constants';
import { getRoute } from 'routes/utils';
import { Package } from 'types/package';
import { UserWithithdraw } from 'types/withdraw';

type UsersWithWalletTableProps = {
  isLoading: boolean;
  data?: any;
  tableParams: PackageFilterFormPaginated;
  updateParams: Dispatch<SetStateAction<PackageFilterFormPaginated>>;
};

export const SubscriptionViewTable = ({
  data,
  isLoading,
  tableParams,
  updateParams,
}: UsersWithWalletTableProps) => {
  const navigate = useNavigate();
  const permissions = usePermissions();
  if (!permissions) return null;
  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue | null>,
    sorter: SorterResult<UserWithithdraw> | SorterResult<UserWithithdraw>[],
  ) => {
    const sortBy = () => {
      if (Array.isArray(sorter)) return;

      const sortOrder =
        sorter.order === 'ascend' ? `${sorter.field}` : `-${sorter.field}`;

      if (sorter?.field === 'last_transaction_date') {
        return {
          order_by_balance: undefined,
          order_by_transaction: sortOrder,
        };
      }
    };

    updateParams({
      ...tableParams,
      page: pagination.current,
      size: pagination.pageSize,
      ...sortBy(),
    });
  };

  return (
    <StyledTableWrapper>
      <StyledTableHeader>
        <RecordCountBadge
          text={'Subscription found'}
          count={data?.total || 0}
        />
      </StyledTableHeader>
      <Table<Package>
        loading={isLoading}
        dataSource={data?.items}
        rowKey='id'
        onChange={handleTableChange}
        pagination={{
          current: tableParams.page,
          defaultPageSize: tableParams.size,
          total: data?.total,
        }}
        onRow={(record: any) => {
          return {
            className: record.status_id !== 1 ? 'clickable-row' : '',
            onClick: () => {
              navigate(getRoute(ROUTES.PACKAGE_EDIT, record.id));
            },
          };
        }}
      >
        <Column
          title={'Facility Name'}
          dataIndex={'name'}
          // width={screens.xxl ? 'auto' : 170}
          render={(_, record: any) => record.name}
        />
        <Column
          title={'Court'}
          dataIndex={'commission'}
          // width={screens.xxl ? 'auto' : 170}
        />
        <Column
          title={'Minimum Per Amount'}
          dataIndex={'cap'}
          // width={screens.xxl ? 'auto' : 130}
        />
        <Column
          title={'Revenue '}
          dataIndex={'cap'}
          // width={screens.xxl ? 'auto' : 130}
        />
        <Column
          title={'Main revenue '}
          dataIndex={'cap'}
          // width={screens.xxl ? 'auto' : 130}
        />
        <Column
          title={'Action'}
          dataIndex={'last_transaction_date'}
          render={() => (
            <Space>
              <EditOutlined />
              <DeleteOutlined />
            </Space>
          )}
        />
      </Table>
    </StyledTableWrapper>
  );
};
